module.exports = __webpack_public_path__ + "static/Resume-7846c31afb39d7626d2c4f11cc322700.pdf";